import { css } from '@lastbrand/web-ui-styled-system/css'

// `InputTextField` owns the field chrome + error text; these only cover the wrapper.
// Field styles go through its `css` prop as a `css.raw` object (not `className`).
export const inputOptionWrapperClass = css({
  width: '100%',
})

export const inputFieldCss = css.raw({
  width: '100%',
  // 40px field height; px literal (no size token). Left padding owned by InputTextField.
  height: '40px',
  textStyle: 'body-14',
})
